'use es6';

import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { OBSIDIAN, OLAF, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const UnstyledButton = props => /*#__PURE__*/_jsx(UIButton, Object.assign({
  use: "unstyled"
}, props));
export default styled(UnstyledButton).withConfig({
  displayName: "StyleProtectedSelectItem",
  componentId: "k3btlr-0"
})(["color:", " !important;background-color:", " !important;.is-focused > &{background-color:", " !important;}"], OBSIDIAN, OLAF, CALYPSO_LIGHT);